import { Loader2 } from "lucide-react";
import { FC } from "react";

const Loader: FC = () => {
  return (
    <div className="min-h-dvh flex items-center justify-center">
      <Loader2 className="animate-spin" />
    </div>
  );
};

export default Loader;
